import * as types from '../constants/actionTypes';
import { fromJS , toJS } from 'immutable';
import mixpanel from 'mixpanel-browser';
mixpanel.init("85e6fe66c3bc0fdf457bf69c74376617");

function uiReducer(state = { tempData : { featuresPage : { device : 'mobileDevices' , feature : 'floorPlan' } , mixpanel : mixpanel } }, action){
  state = fromJS(state)
  switch (action.type) {
    case types.CHANGE_TEMP_DATA:
      const amendmentKeys = Object.keys(action.amendments);
      amendmentKeys.map((key)=>{
        state = state.setIn(['tempData'].concat(key),action.amendments[key])
      })
      return state.toJS()
      break;
    case types.CHANGE_UI_STATE:
      action.amendments.map((amendment)=>{
        amendment.action = (typeof amendment.action === 'undefined') ? 'setIn' : amendment.action;
        if(amendment.action !== 'updateIn'){
          state = state[amendment.action](amendment.keys,amendment.value);
        } else {
          state = state.updateIn(amendment.keys,array => {
            const { type , field , index } = amendment.update;
            if(type === 'push'){
              return array.push(amendment.value);
            } else if(type === 'filter'){
              return (typeof field !== 'undefined') ? (
                array.filter((data)=>{
                  if(data.getIn([field]) !== amendment.value[field]){
                    return data;
                  }
                })
              ) : (
                array.filter((data,dataIndex)=>{
                  if(dataIndex !== index){
                    return (data === 0) ? String(0) : data;
                  }
                })
              ) ;
            }
          })
        }
      })
      return state.toJS()
      break;
    case types.CLEAR_STATE:
      return state.setIn(['tempData'],{})
        .toJS()
      break;
    default:
      return state.toJS();
      break;
  }
}

export default uiReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/uiReducer.js
 **/